import { DataListModel, UbigeoModel } from '@app/src/common/PredictiveInput/DataListModel';

export const hydrateData = (data: UbigeoModel[]) =>
  data.map((item) => ({
    alias: `${item.location_name} ${item.province_name}`,
    data: { ...item }
  })) as DataListModel[]

export const hydrateDataForSearch = (data: any[]) =>
  data.map((item) => ({
    ...item,
    name: item.location
  }));
